import { useContext } from 'react';
import { SECURITY_REPORT_TITLE } from '../../constants/localizations/security';
import { SECURITY_REPORT_PAGE_URL } from '../../constants/security';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import SeoHelmet from '../SeoHelmet';
import { BugcrowdSubmissionForm } from './BugcrowdSubmissionForm';
import css from './security-report.module.scss';

export function SecurityReportRoute() {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  const title = getLocalizedText(SECURITY_REPORT_TITLE);

  return (
    <main className={css.page} data-testid="securityReportPage">
      <SeoHelmet
        title={title}
        description=""
        name="TuneIn"
        image=""
        url={SECURITY_REPORT_PAGE_URL}
        links={[]}
        meta={[]}
        additionalJsonLd={{}}
        includeJsonLd={false}
      />
      <h1 className={css.title}>{title}</h1>
      <BugcrowdSubmissionForm />
    </main>
  );
}
